import { useEffect, useState } from 'react';
import { supabase } from '../../../lib/supabase';

interface Benefit {
  id: string;
  title: string;
  description: string;
  icon: string;
  display_order: number;
}

export default function WhatYouGetSection() {
  const [benefits, setBenefits] = useState<Benefit[]>([]);

  useEffect(() => {
    async function fetchBenefits() {
      try {
        const { data, error } = await supabase
          .from('home_benefits')
          .select('*')
          .eq('is_active', true)
          .order('display_order', { ascending: true });

        if (error) throw error;
        if (data) setBenefits(data);
      } catch (error) {
        console.error('Error fetching benefits:', error);
      }
    }

    fetchBenefits();
  }, []);

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
            Ce que vous obtenez
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Un site business complet, clé en main, pensé pour convertir vos visiteurs en clients
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit) => (
            <div 
              key={benefit.id}
              className="bg-slate-50 p-8 rounded-2xl hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-yellow-600 to-yellow-700 rounded-xl mb-6">
                <i className={`${benefit.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3">
                {benefit.title}
              </h3>
              <p className="text-slate-600 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
